export default __webpack_public_path__ + "static/media/forgive_1.0695a025.jpg";